"use client";

import { useEffect, useState } from "react";
import { getPublicSettings } from "@/lib/api";

/**
 * Wires a form to bot protection. Reads public settings once to learn whether
 * Turnstile is on (and its site key), tracks the current token, and provides a
 * `reset` (bump `resetKey` to remount the widget) for the TURNSTILE_FAILED
 * retry path. When disabled, nothing loads.
 */
export function useTurnstile() {
  const [enabled, setEnabled] = useState(false);
  const [siteKey, setSiteKey] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    let alive = true;
    getPublicSettings()
      .then((s) => {
        if (!alive) return;
        setEnabled(s.turnstileEnabled && Boolean(s.turnstileSiteKey));
        setSiteKey(s.turnstileSiteKey);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  function reset() {
    setToken(null);
    setResetKey((k) => k + 1);
  }

  return { enabled, siteKey, token, setToken, reset, resetKey };
}
